import { UserPagingRequest } from '@/dto/commons/PaginationRequest.dto';
import http from '@/apis';
import { prepareGetQuery } from '@utils/apis.util';
import CreateUserDto from '@/dto/users/CreateUser.dto';
import UpdateUserDto from '@/dto/users/UpdateUser.dto';

class UserService {
  prefix = 'api/admin/users';

  public async list(model: UserPagingRequest) {
    const result = await http.get(`${this.prefix}${prepareGetQuery(model)}`);
    return result.data.result;
  }

  public async minified(model: UserPagingRequest) {
    const result = await http.get(
      `${this.prefix}/minified${prepareGetQuery(model)}`
    );
    return result.data.result;
  }

  public async create(model: CreateUserDto) {
    const result = await http.post(`${this.prefix}`, model);
    return result.data.result;
  }

  public async update(id: number, model: UpdateUserDto) {
    const result = await http.put(`${this.prefix}/${id}`, model);
    return result.data.result;
  }

  public async verify(id: number) {
    const result = await http.put(`${this.prefix}/${id}/verify-account`);
    return result.data.result;
  }

  public async unVerify(id: number) {
    const result = await http.delete(`${this.prefix}/${id}/verify-account`);
    return result.data.result;
  }

  public async restore(id: number) {
    const result = await http.put(`${this.prefix}/${id}/restore`);
    return result.data.result;
  }

  public async delete(id: number) {
    const result = await http.delete(`${this.prefix}/${id}`);
    return result.data.result;
  }

  public async hardDelete(id: number) {
    const result = await http.delete(`${this.prefix}/${id}/hard-delete`);
    return result.data.result;
  }

  public async getUserDetail(id: number) {
    const result = await http.get(`${this.prefix}/${id}`);
    return result.data.result;
  }

  public async genBraintreeToken() {
    const result = await http.post(`api/payment/generate`);
    return result.data.result;
  }

  public async sendClientNonce(model: any) {
    const result = await http.post(`api/payment`, model);
    return result.data.result;
  }
}

export default new UserService();
